/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const InsertMathIcon = /*#__PURE__*/ createSvgIcon(
  'InsertMathIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <path
            d="M9.59 2.92H1.53v.21L6.39 8l-4.86 4.86v.22h8.06M13.18 14.27V1.72M11.88.5H12a1.22 1.22 0 011.22 1.22v0"
            stroke="currentColor"
            strokeMiterlimit={10}
          />
          <path
            d="M14.48.5h-.08a1.22 1.22 0 00-1.22 1.22v0M14.48 15.48h-.08a1.21 1.21 0 01-1.22-1.21v0"
            stroke="currentColor"
            strokeMiterlimit={10}
          />
          <path
            d="M11.88 15.48H12a1.21 1.21 0 001.22-1.21v0"
            stroke="currentColor"
            strokeMiterlimit={10}
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            d="M12.01 3.56H1.8v.28L7.96 10 1.8 16.16v.27h10.21M16.56 17.94V2.04M14.91.5H15A1.54 1.54 0 0116.56 2M18.21.5h-.11A1.54 1.54 0 0016.56 2v0M18.21 19.48h-.11a1.53 1.53 0 01-1.54-1.54v0M14.91 19.48H15a1.53 1.53 0 001.54-1.54"
            stroke="currentColor"
            strokeMiterlimit={10}
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            d="M14.42 4.21H2.07v.33L9.53 12l-7.46 7.46v.33h12.35M19.93 21.62V2.37M17.94.51h.13a1.86 1.86 0 011.86 1.86M21.93.51h-.13a1.87 1.87 0 00-1.87 1.86v0M21.93 23.48h-.13a1.87 1.87 0 01-1.87-1.86v0M17.94 23.48h.13a1.86 1.86 0 001.86-1.86"
            stroke="currentColor"
            strokeMiterlimit={10}
          />
        </>
      ),
    },
  },
  false
);

export default InsertMathIcon;
